// DO NOT EDIT -- generated from fs/services/dx-objects/embeddings.proto

import { ObjectType } from './modeltypes.proto';

export namespace EmbeddingsPublic {

  export const VectorSearchEndpoint = "/grpc/dx_objects.EmbeddingsPublic/VectorSearch";
  export function VectorSearch(sender: (req: VectorSearchRequest, endpoint: string) => Promise<VectorSearchResponse>, req: VectorSearchRequest): { promise: () => Promise<VectorSearchResponse>, endpoint: string } {
    return {
      promise: () => sender(req, VectorSearchEndpoint),
      endpoint: VectorSearchEndpoint
    };
  }
}

export namespace Embeddings {

  export const VectorSearchEndpoint = "/grpc/dx_objects.Embeddings/VectorSearch";
  /** Deprecated: use EmbeddingsPublic.VectorSearch instead. */
  export function VectorSearch(sender: (req: VectorSearchRequest, endpoint: string) => Promise<VectorSearchResponse>, req: VectorSearchRequest): { promise: () => Promise<VectorSearchResponse>, endpoint: string } {
    return {
      promise: () => sender(req, VectorSearchEndpoint),
      endpoint: VectorSearchEndpoint
    };
  }
}

export namespace EmbeddingsAdmin {

  export const MarkEmbeddingNeedsUpdateEndpoint = "/grpc/dx_objects.EmbeddingsAdmin/MarkEmbeddingNeedsUpdate";
  /**
   * MarkEmbeddingNeedsUpdate marks the embedding as needing an update.
   * If an object does not exist yet at all, it will also have entry created in
   * the objects table.
   */
  export function MarkEmbeddingNeedsUpdate(sender: (req: MarkEmbeddingNeedsUpdateRequest, endpoint: string) => Promise<{}>, req: MarkEmbeddingNeedsUpdateRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, MarkEmbeddingNeedsUpdateEndpoint),
      endpoint: MarkEmbeddingNeedsUpdateEndpoint
    };
  }
}

export interface VectorSearchRequest {
  orgId: string;
  text?: string;
  vector?: Vector | null;
  perType?: VectorSearchRequest.PerTypeOptions | null;
  combined?: VectorSearchRequest.CombinedOptions | null;
  removeObjectsWithIssues: boolean;
}

export namespace VectorSearchRequest {
  export enum source {
    text = 2,
    vector = 3
  }

  export function source_oneof(m: VectorSearchRequest): { opt: source.text, val: string } | { opt: source.vector, val: Vector } | null {
    if (m.text != null) { return { opt: source.text, val: m.text } }
    if (m.vector != null) { return { opt: source.vector, val: m.vector } }
    return null;
  }

  export enum options {
    perType = 4,
    combined = 5
  }

  export function options_oneof(m: VectorSearchRequest): { opt: options.combined, val: VectorSearchRequest.CombinedOptions } | { opt: options.perType, val: VectorSearchRequest.PerTypeOptions } | null {
    if (m.perType != null) { return { opt: options.perType, val: m.perType } }
    if (m.combined != null) { return { opt: options.combined, val: m.combined } }
    return null;
  }

  export interface CombinedOptions {
    limit: number;
    dxObjectTypes: ObjectType[];
  }

  export interface PerTypeOptions {
    metrics: number;
    funnels: number;
    segments: number;
    elements: number;
    definedEvents: number;
    pages: number;
    apiEvents: number;
    userProperties: number;
  }
}

export interface VectorSearchResponse {
  metrics: VectorSearchResponse.Result[];
  funnels: VectorSearchResponse.Result[];
  segments: VectorSearchResponse.Result[];
  elements: VectorSearchResponse.Result[];
  definedEvents: VectorSearchResponse.Result[];
  pages: VectorSearchResponse.Result[];
  apiEvents: VectorSearchResponse.Result[];
  userProperties: VectorSearchResponse.Result[];
  combined: VectorSearchResponse.Result[];
}

export namespace VectorSearchResponse {
  export interface Result {
    dxObjectId: string;
    dxObjectType: ObjectType;
    distance: number;
    name: string;
    description: string;
    embeddingPayload: string;
    recentViewCount: number;
    objectReferencesCount: number;
  }
}

export interface Vector {
  values: number[];
}

export interface MarkEmbeddingNeedsUpdateRequest {
  orgId: string;
  dxObjectId: string;
  dxObjectType: ObjectType;
  mod: MarkEmbeddingNeedsUpdateRequest.EmbeddingMod;
}

export namespace MarkEmbeddingNeedsUpdateRequest {
  export enum EmbeddingMod {
    /** Default for unmodded types. */
    EMBEDDING_MOD_NONE = 0,
    /** Property types need mods to understand underlying concrete property type. */
    EMBEDDING_MOD_PROPERTY_INVALID = 0,
    EMBEDDING_MOD_PROPERTY_USER = 1
  }
}
